import Add from '@material-ui/icons/Add'
import React, { useState } from 'react'
import Fade from 'react-reveal/Fade'
import ClientVideoForm from '../../components/ClientVideo/ClientVideoForm/ClientVideoForm'
import ClientVideoKiosks from '../../components/ClientVideo/ClientVideoKiosks/ClientVideoKiosks'
import ViewClientVideo from '../../components/ClientVideo/ViewClientVideo/ViewClientVideo'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Modal from '../../components/UI/Modal/Modal'
import Search from '../../components/UI/Search/Search'
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'

const isVideoGlobal = (video) => {
    if (!video) return false;
    return video.isGlobal === true || video.isGlobal === 'true' || video.isGlobal === 1 || video.isGlobal === '1';
}

const Videos = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [pageCount, setPageCount] = useState(0)
    const [tableData, setTableData] = useState([])
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [videos, setVideos] = React.useState([])
    const [newClientVideoPage, setNewClientVideoPage] = React.useState(false)
    const [view, setView] = React.useState(false)
    const [viewKiosksPage, setViewKiosksPage] = React.useState(false)
    const [clientVideo, setClientVideo] = React.useState('')
    const [modalContent, setModalContent] = useState('');
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شرح ویدئو'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    const ref = React.useRef()

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])
    const changeStateSubmit = (id) => {

        var raw = JSON.stringify({
            video: {
                id: id,
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/clientvideos/changeClientVideoState'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0') {
                    ref.current.closeModal();
                    search();
                }
            })
            .catch(error => console.log())
    }
    const changeState = (id) => {
        setModalContent(<div>
            <div className="row justify-content-center">
                آیا از تغییر وضعیت مطمئن هستید؟
            </div>
            <div className="row justify-content-center w-100 mt-5">
                <div className="col-6">
                    <Button btnType="Success" clicked={() => changeStateSubmit(id)} >بله</Button>
                </div>
                <div className="col-6">
                    <Button btnType="General" clicked={() => {
                        ref.current.closeModal();
                    }} >خیر</Button>
                </div>
            </div>
        </div>);
        ref.current.openModal();
    }
    const viewVideo = (id, data) => {
        const vd = data.filter(v => v.id === id);
        if (!!vd && vd.length > 0) {
            setClientVideo(vd[0])
            setView(true)
            setViewKiosksPage(false)
            setNewClientVideoPage(false)
        }
    }
    const viewVideoKiosks = (id, data) => {
        const vd = data.filter(v => v.id === id);
        if (!!vd && vd.length > 0) {
            setClientVideo(vd[0])
            setViewKiosksPage(true)
            setView(false)
            setNewClientVideoPage(false)
        }
    }
    const removeVideoSubmit = (id) => {

        var raw = JSON.stringify({
            video: {
                id: id,
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/clientvideos/removeClientVideoState'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0') {
                    ref.current.closeModal();
                    props.reload();
                }
            })
            .catch(error => console.log())
    }
    const removeVideo = (id) => {
        setModalContent(<div>
            <div className="row justify-content-center">
                آیا از حذف ویدیو مطمئن هستید؟
            </div>
            <div className="row justify-content-center w-100 mt-5">
                <div className="col-6">
                    <Button btnType="Success" clicked={() => removeVideoSubmit(id)} >بله</Button>
                </div>
                <div className="col-6">
                    <Button btnType="General" clicked={() => {
                        ref.current.closeModal();
                    }} >خیر</Button>
                </div>
            </div>
        </div>)
        ref.current.openModal();
    }
    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "video": {
                "videoName": searchParams.description.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/clientvideos/getClientVideos'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.videos)
                    pushData(newList)
                    setVideos(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'videoName',
                header: 'شرح ویدیو',
                align: 'center',
            },
            {
                accessorKey: 'order',
                header: 'شماره پخش',
                align: 'center',
            },
            {
                accessorKey: 'isGlobalLabel',
                header: 'همگانی',
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: 'وضعیت',
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            const global = isVideoGlobal(d);
            rows.push({
                id: d.id,
                videoName: d.videoName,
                order: d.order,
                isGlobal: global,
                isGlobalLabel: global ? 'همگانی' : '-',
                isActive: d.isActive == '1' ? 'فعال است' : 'فعال نیست',
            });
        })
        buttons.push({ id: 1, text: 'تغییر وضعیت', clicked: changeState });
        buttons.push({ id: 2, text: 'حذف ویدیو', clicked: removeVideo });
        buttons.push({ id: 3, text: 'مشاهده ویدیو', clicked: viewVideo });
        buttons.push({
            id: 4,
            text: 'ویرایش لاکرها',
            clicked: viewVideoKiosks,
        });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const toggleNewLockerForm = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
        setNewClientVideoPage(false)
    }

    const addNewClientVideo = (event, id) => {
        setClientVideo('')
        setNewClientVideoPage(true)
        setView(false)
        setViewKiosksPage(false)
    }

    const backToList = () => {
        setView(false)
        setViewKiosksPage(false)
        setNewClientVideoPage(false)
    }

    const afterSaveKiosks = () => {
        setViewKiosksPage(false)
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }
    const afterCloseModal = (event) => {
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>

    const showList = !newClientVideoPage && !view && !viewKiosksPage;

    return (
        <div>
            {loading ? <Spinner /> : ''}
            {showList ?
                <Fade duration={200} left cascade>
                    <div>
                        <Search class="orders-search" form={form} />
                        {permission != null && permission.includes('KIOSK_WRITE') ?
                            <div className="row justify-content-center mt-3 ml-3">
                                <div className="UserGeneralBtn mb-2">
                                    <div onClick={(event) => addNewClientVideo(event)} className="Add">
                                        <Add className="UserIcon" />
                                    </div>
                                </div>
                            </div>
                            : ''
                        }
                        {rerender ?
                            <Table hasDetails={false} data={videos} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                            :
                            <Table hasDetails={false} data={videos} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                        }
                    </div>
                </Fade>
                :
                <div>
                    {newClientVideoPage ?
                        <ClientVideoForm back={backToList} toggleNewLockerForm={toggleNewLockerForm} />
                        : ''}
                    {view ?
                        <ViewClientVideo back={backToList} clientVideo={clientVideo} />
                        : ''}
                    {viewKiosksPage ?
                        <ClientVideoKiosks
                            back={backToList}
                            clientVideo={clientVideo}
                            onSaved={afterSaveKiosks}
                        />
                        : ''}
                </div>
            }
            <Modal
                content={modalContent}
                ref={ref}
                closePermission="true"
                closeModal=
                {(event) => afterCloseModal(event)}

            />
        </div>
    )
}

export default Videos
